export default [
  {
    path: "/resources/become-an-organizer",
    name: "BecomeAnOrganizer",
    alias: ["/host", "/organizer", "/resources/organizer"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/become-an-organizer";
    }
  },
  {
    path: "/resources/organizer/promoting-your-event",
    name: "PromotingYourEvent",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/organizer-toolkit/promoting-your-event";
    }
  },
  {
    path: "/resources/organizer/academic-organizers",
    name: "AcademicOrganizers",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/organizer-toolkit/academic-organizers";
    }
  },
  {
    path: "/resources/organizer/listing-your-in-person-event",
    name: "ListingYourInPersonEvent",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/listing-your-in-person-event";
    }
  },
  {
    path: "/resources/organizer/hosting-your-in-person-event",
    name: "HostingYourInPersonEvent",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/hosting-your-in-person-event";
    }
  },
  {
    path: "/resources/organizer/in-person-event-checklist",
    name: "InPersonEventChecklist",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/in-person-event-checklist";
    }
  },
  {
    path: "/resources/organizer/listing-your-online-event",
    name: "ListingYourOnlineEvent",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/listing-your-online-event";
    }
  },
  {
    path: "/resources/organizer/hosting-your-online-event",
    name: "HostingYourOnlineEvent",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/hosting-your-online-event";
    }
  },
  {
    path: "/resources/organizer/online-event-checklist",
    name: "OnlineEventChecklist",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/online-event-checklist";
    }
  },
  {
    path: "/resources/organizer/troubleshooting-at-events",
    name: "TroubleshootingAtEvents",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/troubleshooting-at-events";
    }
  },
  {
    path: "/resources/organizer/organizer-faq",
    name: "OrganizerFaq",
    alias: ["/organizer-faq", "/resources/organizer-faq"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/organizer-toolkit/organizer-faq";
    }
  },
  {
    path: "/resources/organizer/organizer-handbook",
    name: "OrganizerHandbook",
    alias: ["/organizer-handbook", "/resources/organizer-handbook"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/organizer-toolkit/organizer-handbook";
    }
  },
  {
    path: "/resources/events-toolkit",
    name: "EventsToolkit",
    alias: ["/resources/downloads", "/downloads"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/organizer-toolkit/events-toolkit";
    }
  }
];
